import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  InputGroup,
  InputGroupAddon,
  Card,
  CardBody,
} from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import { AddCommaNumber, formatDate } from "../../helpers/Utils";
import PerfectScrollbar from "react-perfect-scrollbar";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
import { NotificationManager } from "../../components/common/react-notifications";
// import Select from 'react-select';
// import CustomSelectInput from '../../components/common/CustomSelectInput';

const ContentComponent = ({
  isOpen,
  onToggle,
  onSubmit,
  onChange,
  values_discount,
  values_tax,
  values_fee,
  promotions, // KM có thể chọn tay
  selectedPromotionsFromParent = [], // Khuyến mại đã chọn từ parent
  orders = [], // Danh sách sản phẩm trong giỏ
  customerPhone = "", // SĐT khách hàng
}) => {
  const manualPromotions = promotions.filter((p) => !p.isAutoUse);

  const [selectedPromotions, setSelectedPromotions] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);
  // console.log('selectedPromotions', selectedPromotions);

  // ========== ĐỒNG BỘ STATE TỪ PARENT KHI MODAL MỞ ==========
  useEffect(() => {
    if (
      isOpen &&
      selectedPromotionsFromParent &&
      selectedPromotionsFromParent.length >= 0
    ) {
      setSelectedPromotions(selectedPromotionsFromParent);
    }
  }, [isOpen, selectedPromotionsFromParent]);

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) return;
    if (orders.length === 0) {
      NotificationManager.warning("Vui lòng thêm sản phẩm trước khi nhập mã", "", 3000);
      return;
    }
    setCouponLoading(true);
    try {
      const tokenStr = localStorage.getItem("access_token");
      const cartData = orders.map((item) => ({
        id: item.id,
        quantity: item.count || 1,
        price: parseFloat(item.price) || 0,
        category_id: item.category ? item.category.id : null,
      }));
      const res = await axios.post(
        `${END_POINT}/promotion/validate-code`,
        { code: couponCode.trim(), cartData, customerPhone: customerPhone || null },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );
      if (res.data && res.data.data) {
        const promo = res.data.data;
        // Check if already selected
        if (!selectedPromotions.some((p) => p.id === promo.id)) {
          handleToggleSelection(promo);
        }
        NotificationManager.success(res.data.responseText, "", 3000);
        setCouponCode("");
      }
    } catch (err) {
      const msg = err.response?.data?.responseText || "Mã khuyến mại không hợp lệ";
      NotificationManager.error(msg, "", 3000);
    } finally {
      setCouponLoading(false);
    }
  };

  // const toggleNested = () => {
  //     if (!isNestedModalOpen) {
  //         const manualSelections = selectedPromotions.filter(p => !p.isAutoUse);
  //         setTempManualSelections(manualSelections);
  //     }
  //     setIsNestedModalOpen(!isNestedModalOpen);
  // };

  // // Hàm để xóa một khuyến mãi đã chọn trực tiếp từ modal cha
  // const handleRemoveAutoPromotion = (promotionCode) => {
  //     autoAppliedPromotions.filter(p => p.code !== promotionCode);
  // };

  // const handleRemoveManualPromotion = (promotionCode) => {
  //     setSelectedPromotions(prev => prev.filter(p => p.code !== promotionCode));
  // };

  // Hàm để bật/tắt lựa chọn (cập nhật trực tiếp selectedPromotions)
  const handleToggleSelection = (promotionItem) => {
    const isAlreadySelected = selectedPromotions.some(
      (p) => p.code === promotionItem.code,
    );

    if (isAlreadySelected) {
      // Nếu đã chọn -> bỏ chọn
      setSelectedPromotions((prev) =>
        prev.filter((p) => p.code !== promotionItem.code),
      );
      return;
    }

    // Nếu chưa chọn -> kiểm tra quy tắc stackable
    if (!promotionItem.isStackable) {
      // Chọn một KM non-stackable -> thay thế các KM CÙNG LOẠI, GIỮ LẠI KM KHÁC LOẠI
      // Ví dụ: chọn DISCOUNT non-stackable -> giữ lại các GIFT promotions
      const otherTypePromotions = selectedPromotions.filter(
        (p) => p.promotionType !== promotionItem.promotionType,
      );
      setSelectedPromotions([...otherTypePromotions, promotionItem]);
    } else {
      // Chọn một KM stackable
      // Chỉ kiểm tra non-stackable trong CÙng loại
      const hasNonStackableSameType = selectedPromotions.some(
        (p) =>
          !p.isStackable && p.promotionType === promotionItem.promotionType,
      );
      if (hasNonStackableSameType) {
        alert(
          "Bạn không thể chọn thêm khuyến mãi khi đã có một khuyến mãi không-kết-hợp cùng loại.",
        );
        return;
      }
      setSelectedPromotions((prev) => [...prev, promotionItem]);
    }
  };

  // // Hàm xóa chương trình khuyến mãi đã chọn
  // const handleClearPromotion = () => {
  //     setSelectedPromotions(null);
  //     // Có thể bạn muốn reset cả giá trị discount thủ công ở đây
  //     // Ví dụ: onChange({ target: { name: 'value', value: '' }}, 'discount_form');
  // }

  const formatCurrency = (value) => {
    if (!value) return "";
    const numberValue = parseFloat(String(value).replace(/\./g, ""));
    if (isNaN(numberValue)) return "";
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(numberValue);
  };

  const formatDiscount = (item) => {
    // Hỗ trợ cả hai kiểu key (discountUnit/discountValue và discount_type/discount_value)
    const discountValue = item.discountValue || item.discount_value;
    const discountUnit =
      item.discountUnit ||
      (item.discount_type === 2 ? "PERCENT" : "FIXED_AMOUNT");
    const maxDiscount = item.maxDiscount || item.max_discount;

    const discountUnitDisplay = discountUnit === "PERCENT" ? "%" : "đ";
    let description = `giảm ${discountValue}${discountUnitDisplay}`;

    if (maxDiscount && parseFloat(maxDiscount) > 0) {
      description += `, tối đa ${formatCurrency(maxDiscount)}`;
    }
    return description;
  };

  const generatePromotionDescriptions = (promotion) => {
    if (
      !promotion.actions ||
      promotion.actions.length === 0 ||
      !promotion.conditions ||
      promotion.conditions.length === 0
    ) {
      return ["Không có thông tin chi tiết."];
    }

    const action = promotion.actions[0];
    const condition = promotion.conditions[0];
    const descriptions = [];

    switch (promotion.promotionType) {
      // ==========================================================
      // TRƯỜNG HỢP GIẢM GIÁ (DISCOUNT)
      // ==========================================================
      case "DISCOUNT":
        switch (action.actionType) {
          // --- Giảm giá trên toàn bộ đơn hàng ---
          case "ORDER_DISCOUNT":
            if (condition.conditionType === "MIN_ORDER_VALUE") {
              // ID: 42
              if (!Array.isArray(action.actionItems))
                return ["Thông tin khuyến mại không hợp lệ."];
              return action.actionItems.map((item) => {
                let desc = `${formatDiscount(item)} cho đơn hàng từ ${formatCurrency(item.fromValue)}`;
                if (item.toValue) {
                  desc += ` đến ${formatCurrency(item.toValue)}`;
                } else {
                  desc += " trở lên";
                }
                return desc + ".";
              });
            }
            if (condition.conditionType === "CUSTOMER_POINTS") {
              // ID: 51
              if (!Array.isArray(action.actionItems))
                return ["Thông tin khuyến mại không hợp lệ."];
              return action.actionItems.map((item) => {
                return `Dùng ${formatCurrency(item.fromPoints).replace("đ", "")} điểm để được ${formatDiscount(item)} trên tổng đơn hàng.`;
              });
            }
            if (condition.conditionType === "FIRST_ORDER") {
              // ID: 52
              // Thông tin giảm giá nằm trực tiếp trong action
              const discountDesc = formatDiscount(action);
              return [
                `${discountDesc.charAt(0).toUpperCase() + discountDesc.slice(1)} cho đơn hàng đầu tiên.`,
              ];
            }
            break;

          // --- Giảm giá trên sản phẩm cụ thể ---
          case "ITEM_DISCOUNT":
            if (condition.conditionType === "MIN_CATEGORY_QUANTITY") {
              // ID: 53
              if (!Array.isArray(action.actionItems))
                return ["Thông tin khuyến mại không hợp lệ."];
              return action.actionItems.map((item) => {
                return `Mua từ ${item.fromQuantity} sản phẩm thuộc danh mục bất kỳ sẽ được ${formatDiscount(item)} trên các danh mục đó.`;
              });
            }
            if (condition.conditionType === "MIN_PRODUCT_QUANTITY") {
              // ID: 54
              if (!Array.isArray(action.actionItems))
                return ["Thông tin khuyến mại không hợp lệ."];
              return action.actionItems.map((item) => {
                return `Mua từ ${item.fromQuantity} sản phẩm bất kỳ sẽ được ${formatDiscount(item)} trên các sản phẩm đó.`;
              });
            }
            if (condition.conditionType === "CONTAINS_PRODUCTS") {
              // ID: 56
              if (!Array.isArray(action.actionItems))
                return ["Thông tin khuyến mại không hợp lệ."];
              return action.actionItems.map((item) => {
                const productList = item?.product
                  ?.map((p) => p.label)
                  .join(", ");
                return `${formatDiscount(item).charAt(0).toUpperCase() + formatDiscount(item).slice(1)} khi mua các sản phẩm: ${productList}.`;
              });
            }
            if (condition.conditionType === "CONTAINS_CATEGORIES") {
              // ID: 57
              if (!Array.isArray(action.actionItems))
                return ["Thông tin khuyến mại không hợp lệ."];
              return action.actionItems.map((item) => {
                const categoryList = item?.category
                  ?.map((c) => c.label)
                  .join(", ");
                return `${formatDiscount(item).charAt(0).toUpperCase() + formatDiscount(item).slice(1)} khi mua sản phẩm thuộc danh mục: ${categoryList}.`;
              });
            }
            break;
        }
        break;

      // ==========================================================
      // TRƯỜNG HỢP TẶNG QUÀ (GIFT)
      // ==========================================================
      case "GIFT":
        if (action.actionType === "GIVE_GIFT") {
          if (condition.conditionType === "MIN_ORDER_VALUE") {
            // ID: 47
            if (
              !action.actionItems?.rules ||
              !Array.isArray(action.actionItems.rules)
            )
              return ["Thông tin khuyến mại không hợp lệ."];
            return action.actionItems.rules.map((rule) => {
              // Hỗ trợ cả format cũ (price_start, ogp_gift) và format mới (fromValue, gifts)
              const priceStart = rule.price_start || rule.fromValue;
              const priceEnd = rule.price_end || rule.toValue;
              const giftItems = rule.ogp_gift || rule.gifts || [];

              const giftList = giftItems
                .map((gift) => {
                  const qty = gift.quantity || 1;
                  const name =
                    gift.label || gift.productName || gift.value || "Quà tặng";
                  return `${qty} ${name}`;
                })
                .join(" và ");

              let desc = `Tặng ${giftList || "quà"} cho đơn hàng từ ${formatCurrency(priceStart)}`;
              if (priceEnd) {
                desc += ` đến ${formatCurrency(priceEnd)}`;
              } else {
                desc += " trở lên";
              }
              return desc + ".";
            });
          }
          if (condition.conditionType === "CUSTOMER_POINTS") {
            // ID: 48
            if (!Array.isArray(action.actionItems))
              return ["Thông tin khuyến mại không hợp lệ."];
            return action.actionItems.map((item) => {
              // Vì không có label sản phẩm, ta sẽ mô tả chung chung
              const giftList = item?.cpgp_gift
                ?.map((gift) => `${gift.quantity} quà tặng (${gift.value})`)
                .join(" và ");
              return `Dùng ${formatCurrency(item.customer_point).replace("đ", "")} điểm để đổi lấy bộ quà tặng: ${giftList}.`;
            });
          }
          if (condition.conditionType === "CONTAINS_PRODUCTS") {
            // ID: 55 (Mua X Tặng Y)
            if (!Array.isArray(action.actionItems))
              return ["Thông tin khuyến mại không hợp lệ."];
            return action.actionItems.map((item) => {
              const buyList = item.pgp_buy
                ?.map((p) => `${p.quantity} "${p.label}"`)
                .join(" và ");
              const giftList = item.pgp_gift
                ?.map((p) => `${p.quantity} "${p.label}"`)
                .join(" và ");
              return `Mua ${buyList} sẽ được tặng ngay ${giftList}.`;
            });
          }
        }
        break;

      default:
        return [`Khuyến mãi loại: ${promotion.promotionType}`];
    }

    // Trả về mảng rỗng nếu không có case nào khớp
    return descriptions.length > 0
      ? descriptions
      : ["Không thể tạo mô tả cho loại khuyến mại này."];
  };

  const dateLeft = (endDate) => {
    const now = new Date();
    const end = new Date(endDate);
    const diffTime = end - now;
    if (diffTime <= 0) return "Hết hạn";
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(
      (diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    return `Hết hạn sau ${diffDays} ngày ${diffHours} giờ`;
  };

  const PromotionCard = ({
    item,
    isSelected,
    onSelect,
    showCheckbox = false,
    onRemove,
    disabled = false,
  }) => {
    if (!item) return null;
    return (
      <Card
        className={`mb-3 ${disabled ? "disabled-card" : ""} ${isSelected ? "border-primary" : ""}`}
        onClick={disabled ? null : onSelect}
        style={{
          cursor: disabled ? "not-allowed" : onSelect ? "pointer" : "default",
          position: "relative",
        }}
      >
        {onRemove && (
          <button
            className="position-absolute"
            style={{
              top: "-15px",
              right: "10px",
              background: "none",
              border: "none",
              fontSize: "1.2rem",
              zIndex: 2,
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation(); // Ngăn sự kiện click vào card
              onRemove();
            }}
          >
            &times;
          </button>
        )}
        <CardBody className="p-3">
          <div className="mb-2 d-flex">
            {item.isAutoUse && (
              <span className="badge badge-pill badge-info mr-1">Tự động</span>
            )}
            {item.isStackable ? (
              <span className="badge badge-pill badge-success">
                Có thể kết hợp
              </span>
            ) : (
              <span className="badge badge-pill badge-warning">
                Không kết hợp
              </span>
            )}
          </div>
          <div className="pt-2 d-flex justify-content-between align-items-center">
            <div style={{ flex: 1 }}>
              <div className="d-flex justify-item-between align-items-center">
                <span
                  style={{
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    padding: "2px 8px",
                    fontSize: "0.8em",
                  }}
                >
                  {item.promotionType === "DISCOUNT" ? "Giảm giá" : "Quà tặng"}
                </span>
                <div className="ml-auto text-muted text-small">
                  Mã: {item.code}
                </div>
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  marginTop: "0.5rem",
                  marginBottom: "0.5rem",
                }}
              >
                {item.name}
              </div>
              <div style={{ color: "#888", fontSize: "0.9em" }}>
                {/* <div className='mb-2'>Giảm giá 10% cho đơn hàng từ 500.000đ - 900.000đ</div> */}
                <ul className="mb-2">
                  {generatePromotionDescriptions(item).map((desc, index) => (
                    <li key={index}>{desc}</li>
                  ))}
                </ul>
                <div>
                  <i className="simple-icon-calendar mr-2" /> Áp dụng từ:{" "}
                  {formatDate(item.startDate)} - {formatDate(item.endDate)}
                </div>
                <div>
                  <i className="simple-icon-user mr-2" /> Mỗi khách hàng dùng{" "}
                  {item.maxUsagePerCustomer} lần.
                  {item.maxUsageTotal - item.usageCount > 0 &&
                    ` Còn lại ${item.maxUsageTotal - item.usageCount} lượt.`}
                </div>
                <div style={{ color: "#ff5050", marginTop: "0.5rem" }}>
                  {dateLeft(item.endDate)}
                </div>
              </div>
            </div>
            {showCheckbox && (
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={`promo-${item.code}`}
                  checked={isSelected}
                  onChange={onSelect}
                  disabled={disabled}
                />
                <label
                  className="custom-control-label"
                  htmlFor={`promo-${item.code}`}
                ></label>
              </div>
            )}
          </div>
          {/* {showRadio &&
                        (<div className='custom-control custom-radio'>
                            <input
                                type='radio'
                                className='custom-control-input'
                                id={`promo-${item.code}`} // Thêm ID duy nhất
                                name="promotion-selection" // Cùng name để hoạt động như radio group
                                checked={isSelected}
                                onChange={onSelect} // onChange để đảm bảo radio được cập nhật
                            />
                            <label className='custom-control-label' htmlFor={`promo-${item.code}`} />
                        </div>
                    )} */}
        </CardBody>
      </Card>
    );
  };

  return (
    <Modal
      autoFocus={false}
      isOpen={isOpen}
      toggle={onToggle}
      wrapClassName="modal-right"
      backdrop={true}
    >
      <ModalHeader toggle={onToggle}>
        <IntlMessages id="discount.add-feetax" />
      </ModalHeader>
      <ModalBody className="scrool modal-right-add">
        <PerfectScrollbar
          options={{
            suppressScrollX: true,
            wheelPropagation: false,
          }}
          id="modal-right__body"
        >
          {/* {autoAppliedPromotions.length > 0 && (
                        <>
                            <Label className='text-muted mt-4'>Khuyến mãi được tự động áp dụng</Label>
                            <div className="mb-3">
                                {autoAppliedPromotions.map(promo => (
                                    <PromotionCard key={promo.code} item={promo}/>
                                ))}
                            </div>
                            <Separator className="mb-4" />
                        </>
                    )} */}
          <Label className="text-muted mt-4">Nhập mã khuyến mại</Label>
          <InputGroup className="mb-3">
            <Input
              type="text"
              placeholder="Nhập mã KM..."
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
              onKeyPress={(e) => e.key === "Enter" && handleApplyCoupon()}
              disabled={couponLoading}
            />
            <InputGroupAddon addonType="append">
              <Button
                color="primary"
                onClick={handleApplyCoupon}
                disabled={couponLoading || !couponCode.trim()}
              >
                {couponLoading ? "..." : "Áp dụng"}
              </Button>
            </InputGroupAddon>
          </InputGroup>
          <Separator className="mb-4" />
          {manualPromotions.length > 0 && (
            <>
              <Label className="text-muted mt-4">
                Khuyến mãi có thể áp dụng
              </Label>
              <div className="mb-3">
                {manualPromotions?.map((item) => {
                  const hasNonStackableSelected = selectedPromotions.some(
                    (p) => !p.isStackable,
                  );
                  const isSelected = selectedPromotions.some(
                    (p) => p.code === item.code,
                  );
                  let isDisabled = false;

                  if (hasNonStackableSelected && !isSelected) {
                    // Nếu đã chọn 1 KM non-stackable, vô hiệu hóa tất cả các KM khác
                    isDisabled = true;
                  } else if (
                    !item.isStackable &&
                    selectedPromotions.length > 0 &&
                    !isSelected
                  ) {
                    // Nếu đang định chọn 1 KM non-stackable trong khi đã có lựa chọn khác
                    // Vẫn để chọn, logic sẽ xử lý confirm
                  }

                  return (
                    <PromotionCard
                      key={item.code}
                      item={item}
                      isSelected={isSelected}
                      onSelect={() => handleToggleSelection(item)}
                      showCheckbox={true}
                      disabled={isDisabled}
                    />
                  );
                })}
              </div>
              <Separator className="mb-4" />
            </>
          )}
          {/* <Label className='text-muted'>
                        Khuyến mại thủ công
                    </Label>
                    {selectedPromotions.filter(p => !p.isAutoUse).length > 0 && (
                        <div className="mb-3">
                            {selectedPromotions.filter(p => !p.isAutoUse).map(promo => (
                                <PromotionCard 
                                    key={promo.code} 
                                    item={promo} 
                                    onRemove={() => handleRemoveManualPromotion(promo.code)}
                                />
                            ))}
                        </div>
                    )} */}

          {/* {manualPromotions && manualPromotions.length > 0 && (
                        <div className='d-flex justify-content-between align-items-center mb-3'
                            style={{border: '1px solid #d7d7d7', borderRadius: '0.625rem', padding: '8px 15px', cursor: 'pointer' }}
                            onClick={toggleNested}
                        >
                            {selectedPromotions.filter(p => !p.isAutoUse).length > 0 ? 'Thêm / Thay đổi khuyến mại' : 'Chọn chương trình khuyến mại có sẵn'}
                            <i className='simple-icon-plus' style={{ marginLeft: 10 }} />
                        </div> 
                    )} */}
          {/* <Modal
                        isOpen={isNestedModalOpen}
                        toggle={toggleNested}
                        wrapClassName='modal-right'
                    >
                        <ModalHeader toggle={toggleNested}>Thêm chương trình khuyến mại</ModalHeader>
                        <ModalBody className='scrool modal-right-add'>
                            <PerfectScrollbar
                                options={{
                                    suppressScrollX: true,
                                    wheelPropagation: false,
                                }}
                                id='modal-right__body'
                            >
                                {(() => {
                                    const hasNonStackableSelected = tempManualSelections.some(p => !p.isStackable);
                                    
                                    return manualPromotions?.map((item) => {
                                        const isSelected = tempManualSelections.some(p => p.code === item.code);
                                        let isDisabled = false;

                                        if (hasNonStackableSelected && !isSelected) {
                                            // Nếu đã chọn 1 KM non-stackable, vô hiệu hóa tất cả các KM khác
                                            isDisabled = true;
                                        } else if (!item.isStackable && tempManualSelections.length > 0 && !isSelected) {
                                            // Nếu đang định chọn 1 KM non-stackable trong khi đã có lựa chọn khác
                                            // Vẫn để chọn, logic sẽ xử lý confirm
                                        }

                                        return (
                                            <PromotionCard 
                                                key={item.code} 
                                                item={item}
                                                isSelected={isSelected}
                                                onSelect={() => handleToggleTempSelection(item)}
                                                showCheckbox={true} 
                                                disabled={isDisabled}
                                            />
                                        );
                                    });
                                })()}
                            </PerfectScrollbar>
                        </ModalBody>
                        <ModalFooter>
                            <Button color='secondary' onClick={toggleNested}>Hủy</Button>
                            <Button color='primary' onClick={handleConfirmSelection}>Chọn</Button>
                        </ModalFooter>
                    </Modal> */}
          <InputGroup>
            <Colxx xxs="6" className="p-0">
              <Input
                autoFocus={true}
                type="text"
                name="value"
                id="value"
                className="h-100 border-radius-topbot-left"
                value={AddCommaNumber(values_discount.value)}
                onChange={(e) => onChange(e, "discount_form")}
              />
            </Colxx>
            <Colxx xxs="3" className="p-0">
              <Button
                name="type"
                className="w-100 border-radius-0 h-100"
                color="primary"
                outline
                size="sm"
                onClick={(e) => onChange(e, "discount_form", "percent")}
                active={values_discount.type === "percent"}
              >
                %
              </Button>
            </Colxx>
            <Colxx xxs="3" className="p-0">
              <Button
                name="type"
                className="w-100 border-radius-topbot-right h-100"
                color="primary"
                outline
                size="sm"
                onClick={(e) => onChange(e, "discount_form", "price")}
                active={values_discount.type === "price"}
              >
                VNĐ
              </Button>
            </Colxx>
          </InputGroup>
          <Input
            className="mt-3"
            value={values_discount.note}
            onChange={(e) => onChange(e, "discount_form")}
            name="note"
            placeholder="Ghi chú"
            // placeholder={<IntlMessages id='discount.note' />}
          />
          <Separator className="mt-4 mb-4" />
          <Label className="text-muted">
            <IntlMessages id="discount.tax" />
          </Label>

          <InputGroup>
            <Colxx xxs="6" className="p-0">
              <Input
                type="text"
                name="value"
                id="value"
                className="h-100 border-radius-topbot-left"
                value={AddCommaNumber(values_tax?.value)}
                onChange={(e) => onChange(e, "tax_fee")}
              />
            </Colxx>
            <Colxx xxs="3" className="p-0">
              <Button
                name="type"
                className="w-100 border-radius-0 h-100"
                color="primary"
                outline
                size="sm"
                onClick={(e) => onChange(e, "tax_fee", "percent")}
                active={values_tax?.type === "percent"}
              >
                %
              </Button>
            </Colxx>
            <Colxx xxs="3" className="p-0">
              <Button
                name="type"
                className="w-100 border-radius-topbot-right h-100"
                color="primary"
                outline
                size="sm"
                onClick={(e) => onChange(e, "tax_fee", "price")}
                active={values_tax?.type === "price"}
              >
                VNĐ
              </Button>
            </Colxx>
          </InputGroup>
          <Input
            className="mt-3"
            value={values_tax?.note}
            onChange={(e) => onChange(e, "tax_fee")}
            name="note"
            placeholder="Ghi chú"
            // placeholder={<IntlMessages id='discount.note' />}
          />
          <Separator className="mt-4 mb-4" />
          <Label className="text-muted">
            <IntlMessages id="discount.fee-other" />
          </Label>

          <Input
            className="mb-3"
            name="label"
            type="select"
            value={values_fee?.label || "other"}
            onChange={(e) => onChange(e, "fee_other")}
          >
            <option value="shipping">
              <IntlMessages id="order.adjustment.shipping-fee" />
            </option>
            <option value="service">
              <IntlMessages id="order.adjustment.service-fee" />
            </option>
            <option value="packing">
              <IntlMessages id="order.adjustment.packing-fee" />
            </option>
            <option value="other">
              <IntlMessages id="order.adjustment.other-fee" />
            </option>
          </Input>

          <InputGroup>
            <Colxx xxs="6" className="p-0">
              <Input
                type="text"
                name="value"
                id="value"
                className="h-100 border-radius-topbot-left"
                value={AddCommaNumber(values_fee?.value)}
                onChange={(e) => onChange(e, "fee_other")}
              />
            </Colxx>
            <Colxx xxs="3" className="p-0">
              <Button
                name="type"
                className="w-100 border-radius-0 h-100"
                color="primary"
                outline
                size="sm"
                onClick={(e) => onChange(e, "fee_other", "percent")}
                active={values_fee?.type === "percent"}
              >
                %
              </Button>
            </Colxx>
            <Colxx xxs="3" className="p-0">
              <Button
                name="type"
                className="w-100 border-radius-topbot-right h-100"
                color="primary"
                outline
                size="sm"
                onClick={(e) => onChange(e, "fee_other", "price")}
                active={values_fee?.type === "price"}
              >
                VNĐ
              </Button>
            </Colxx>
          </InputGroup>
          <Input
            className="mt-3"
            value={values_fee?.note}
            onChange={(e) => onChange(e, "fee_other")}
            name="note"
            placeholder="Ghi chú"
            // placeholder={<IntlMessages id='discount.note' />}
          />
        </PerfectScrollbar>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => onSubmit(selectedPromotions)}>
          <IntlMessages id="general.btn-add" />
        </Button>{" "}
      </ModalFooter>
    </Modal>
  );
};

export default ContentComponent;
